@if (surveyConditionalsService.conditionForm$().get('optionId')?.value) {
  <empathy-selected-value-view (onClear)="onClearSelectedOption()">
    <div class="eiq-id-badge" slot="badge">
      <span> {{ surveyConditionalsService.conditionForm$().get('optionId').value | toPlainText }}</span>
    </div>
    <ng-container slot="text">{{
      surveyConditionalsService.conditionForm$().get('optionId').value | optionValueOrText: surveyConditionalsService.questionSelected$() : true | toPlainText
    }}</ng-container>
  </empathy-selected-value-view>
} @else {
  <mat-form-field class="conditional__full-width" appearance="outline" [subscriptSizing]="'dynamic'">
    <mat-select [formControl]="surveyConditionalsService.conditionForm$().get('optionId') | toFormControl">
      @for (option of options$(); track option.id) {
        <mat-option [value]="option.id">{{ option.text | toPlainText }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
